import { useContext } from 'react';
import { ConfirmationContext } from './ConfirmationProvider';

/**
 * Hook for showing a confirmation dialog.
 *
 * @returns {Object} Confirmation methods
 * @returns {Function} confirm - Shows the confirmation dialog with the provided options
 * @returns {Function} close - Closes the confirmation dialog
 *
 * @example
 * ```tsx
 * const { confirm, close } = useConfirmation();
 *
 * const handleDelete = () => {
 *   confirm({
 *     title: 'Delete Item',
 *     message: 'Are you sure you want to delete this item?',
 *     confirmText: 'Delete',
 *     cancelText: 'Cancel',
 *     onConfirm: async () => {
 *       await deleteItem();
 *       close();
 *     }
 *   });
 * };
 * ```
 */
export const useConfirmation = () => {
  const context = useContext(ConfirmationContext);

  if (!context) {
    throw new Error('useConfirmation must be used within a ConfirmationProvider');
  }

  return context;
};
